import { createContext } from 'react';

const MapsJsApiContext = createContext();

export default MapsJsApiContext;
